import React from 'react'
import './NavBar.scss'

export const DesktopNavBarButton = ({
  className,
  dangerouslySetInnerHTML,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      className={className}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
    ></button>
  )
}
